var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAuto(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "#7ed957",
    height: 114.8,
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "30.0 47.6 150.0 114.8",
    width: 150,
    zoomAndPan: "magnify",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "change1_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M139.6 105L110.8 105 116.5 76.3 145.4 76.3 139.6 105z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.9 105L53.1 105 58.8 76.3 87.7 76.3 81.9 105z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128 162.4L99.2 162.4 105 133.7 133.8 133.7 128 162.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.7 133.7L133.8 133.7 139.6 105 168.4 105 162.7 133.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.2 76.3L145.4 76.3 151.2 47.6 180 47.6 174.2 76.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.5 76.3L87.7 76.3 93.5 47.6 122.3 47.6 116.5 76.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.8 76.3L30 76.3 35.8 47.6 64.6 47.6 58.8 76.3z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuto);
export default __webpack_public_path__ + "static/media/auto.a8b199f046c089d5cff4a7ac30e2e627.svg";
export { ForwardRef as ReactComponent };